let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3HzNK")).then(() => parcelRequire('4RuJw'));